// Makes table rows clickable
// needs a url, turbp_frame as a data attribute

import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ['row']
  static values = { url: String, newTab: Boolean }

  handleClick(event) {
    if (this.#shouldIgnore(event)) {
      return;
    }

    Turbo.visit(this.rowTarget.dataset.url, { frame: this.rowTarget.dataset.turboFrame, action: this.rowTarget.dataset.turboAction })
  }

  navigate(event) {
    if (this.#shouldIgnore(event, '.dropdown, .dropdown-menu, [data-no-navigate]')) {
      return;
    }

    // Navigate to the URL (optionally in a new tab)
    if (this.newTabValue) {
      window.open(this.urlValue, '_blank', 'noopener');
    } else {
      window.location.href = this.urlValue;
    }
  }

  connect() {
    // Add cursor pointer to indicate clickability
    this.element.style.cursor = 'pointer';
  }

  // Clicks on interactive descendants, and the click that ends a text selection
  // (the user is copying, not navigating), leave the row alone.
  #shouldIgnore(event, extraSelectors = null) {
    const selectors = ['a, button, input, select, textarea, [data-bs-toggle]', extraSelectors].filter(Boolean).join(', ');
    if (event.target.closest(selectors)) {
      return true;
    }

    const selection = window.getSelection();
    if (selection.toString().length > 0) {
      return true;
    }

    return selection.rangeCount > 0 && !selection.getRangeAt(0).collapsed;
  }
}
